import { FC } from "react";

import dynamic from "next/dynamic";

import { TicketingSkeletonProps } from "./types";

export const TicketingSkeleton = dynamic(
  () => import("./TicketingSkeletonSsr").then((mod) => mod.TicketingSkeletonSsr),
  {
    ssr: false,
  }
) as FC<TicketingSkeletonProps>;
